module.exports = __webpack_public_path__ + "static/P6-d313b7beac436eb27da460ce0736546b.jpeg";